<template>
	<div>
		<b-modal :no-close-on-backdrop="true" size="lg" id="link4" scrollable visible :title="$t('gen.rights')" @hide="$emit('close')">

			<div>
				<div v-html="privacy_content.link_four"></div>
			</div>

			<template slot="modal-footer">
				<b-button @click.prevent="closeModal" size="sm">{{ $t('gen.close') }}</b-button>
			</template>

		</b-modal>
	</div>
</template>

<script>

import mixins from '@/mixins.js'

export default {
	data: function() {
		return {
			privacy_content: false
		}
	},
	mixins: [
		mixins.users
	],
	created: function() {
		this.fetchData();
	},
	methods: {
		closeModal: function() {
			this.$emit('close');
		},
		fetchData: function() {
			this.apiCookiePolicy().then(function(data) {
				this.privacy_content = data.data;
			});
		}
	}
};

</script>